import { render, staticRenderFns } from "./PDFMaterialMultiPage.vue?vue&type=template&id=c8c7c32a&"
import script from "./PDFMaterialMultiPage.vue?vue&type=script&lang=js&"
export * from "./PDFMaterialMultiPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports